// This noop provider forces the app to always use an online boot.
export const noopPersistedStateProvider = Object.freeze({
  tryClearPersistedStateAsync: () => Promise.resolve(),
  loadInitialPersistedStateAsync: () => Promise.resolve(undefined),
});
